import { Form } from '@components/form/Form'
import { FormContextProvider } from '@contexts/FormContext'
import FormEditorHeader from '@layouts/components/FormEditorHeader'
import { Form as FormModel } from '@models/Form'
import { FormItem } from '@models/FormItem'
import { FormPage } from '@models/FormPage'
import { createForm } from '@services/FormService'
import { Spin } from 'antd'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const FormsCreatePage = () => {
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const onSubmit = (values: any) => {
    setIsLoading(true)

    createForm({
      ...values,
      pages: values.pages.map((page: FormPage) => ({
        ...page,
        items: page.items.map((item: FormItem) => ({
          ...item,
          type: typeof item.type === 'object' ? item.type.id : item.type, // Remplace `type` par son `id`
          associatedItems: item.associatedItems?.map((associatedItem) => {
            return typeof associatedItem === 'object'
              ? associatedItem.id
              : associatedItem // Remplace `associatedItem` par son `id`
          }),
        })),
      })),
    } as FormModel).then((response) => {
      navigate(`/forms/${response.data.message}`)
    })
  }

  return (
    <FormContextProvider onSubmit={onSubmit}>
      <FormEditorHeader />
      {isLoading && <Spin />}
      <Form.Wrapper />
    </FormContextProvider>
  )
}

export default FormsCreatePage
